module.exports = __webpack_public_path__ + "img/20220805140952.064dac3a.jpg";